




























import { defineComponent, reactive } from '@vue/composition-api'
import { IUser } from '@/types/user'
import { UserRole } from '@/types/user'

type Props = {
  user: IUser
  isAutomatic: boolean
}

export default defineComponent({
  name: 'SpecialOfferSearchInput',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props: Props, context) {
    const state = reactive({
      id: null,
      nameAdmin: null,
      title: null,
    })

    const search = () => {
      const query = Object.entries(state)
        .filter(([_key, value]) => value !== null)
        .reduce((prev, [key, value]) => {
          prev[key] = value
          return prev
        }, {} as any)

      context.emit('on-search', query)
    }

    const reset = () => {
      state.id = null
      state.nameAdmin = null
      state.title = null

      context.emit('on-reset')
    }

    return {
      state,
      props,
      UserRole,
      search,
      reset,
    }
  },
})
